import React, { useEffect, useRef } from "react";

const Latex = ({ children }) => {
  const container = useRef(null);

  useEffect(() => {
    if (window.MathJax && container.current) {
      // 1. Clean content:
      let content = (children || "")
        .trim() // remove leading/trailing whitespace
        .replace(/(\n|\s)*$/, "") // remove trailing newlines and spaces
        .replace(/\n/g, "<br>"); // replace remaining newlines with <br>

      container.current.innerHTML = content;

      // 2. Typeset with MathJax v3+
      if (typeof window.MathJax.typesetPromise === "function") {
        window.MathJax.typesetPromise([container.current]).catch((err) => {
          console.error("MathJax typeset failed:", err);
        });
      }
    }
  }, [children]);

  return <div ref={container} />;
};

export default Latex;
